export default "__VITE_ASSET__BAJ8bYxk__"